var RES_TYPES_TO_PARSER = {
    'json': 'json',
    'text': 'text',
    default: 'blob'
};
var C_TYPE_HEADER_KEY = 'content-type';
export function getResParser(contentType) {
    if (contentType.includes('application/json')) {
        return RES_TYPES_TO_PARSER.json;
    }
    var type = contentType.split('/').shift();
    return type && RES_TYPES_TO_PARSER[type] || RES_TYPES_TO_PARSER.default;
}
export function stopPromiseChain() {
    return Promise.resolve();
}
export function rejectOrCb(cb, opts) {
    var isMounted = opts.isMounted, data = opts.data;
    if (isMounted) {
        cb(data, isMounted);
    }
    else {
        stopPromiseChain();
    }
}
export function getCTypeHeaderVal(response) {
    var _a;
    var headerVal;
    if ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.get) {
        headerVal = response.headers.get(C_TYPE_HEADER_KEY);
    }
    else if (response === null || response === void 0 ? void 0 : response.headers) {
        headerVal = response.headers[C_TYPE_HEADER_KEY];
    }
    return headerVal || 'default';
}
/**
 * @description HOF for requests
 */
export function cancelable(fn, controller) {
    var _controller = controller || new AbortController();
    var promise = fn(_controller);
    promise['cancel'] = function () { return _controller.abort(); };
    return promise;
}
export function getErrorBody(data) {
    if (typeof data === 'object' && 'data' in data) {
        return data.data;
    }
    return data;
}
